const offers = [
    {
      title: "JK Copier Paper, 75 GSM",
      size: "210 × 297 mm (A4)",
      quote: "Request a Quote",
      desc:
        "Premium quality copier paper suitable for offices, schools and commercial printing. Bulk order discounts available.",
    },
    {
      title: "White Box Copier FSC® Certified, 70 GSM",
      size: "210 × 297 mm (A4)",
      quote: "Request a Quote",
      desc:
        "FSC® Certified copier paper with excellent print performance. Special pricing available for wholesale and bulk purchases.",
    },
  ];
  
  export default function FeaturedOffers() {
    return (
      <section className="featured-offers" id="offers">
  
        <div className="section-heading">
          <h2>Current Special Offers</h2>
          <p>
            Explore our latest promotions on premium paper products.
          </p>
        </div>
  
        <div className="offer-grid">
  
          {offers.map((offer, index) => (
  
            <div className="offer-card" key={index}>
  
              <div className="offer-header">
  
                <h3>{offer.title}</h3>
  
                <span>{offer.size}</span>
  
              </div>
  
              <div className="offer-body">
  
                <h4>{offer.quote}</h4>
  
                <p>{offer.desc}</p>
  
                <a href="/contact" className="offer-btn">
                  Make an Enquiry
                </a>
  
              </div>
  
            </div>
  
          ))}
  
        </div>
  
        <div className="offer-note">
          Prices and availability are subject to stock levels.
          Contact our sales team for the latest offers and customised quotations.
        </div>
  
      </section>
    );
  }